<template>
  <nav class="toolbar">
    <InputSearch
      class="search"
      :focus="shouldFocusSearch"
      :placeholder="searchPlaceholder"
      :value="searchTerm"
      @input="triggerSearch"
    />
  </nav>
</template>

<script>
import {
  InputSearch,
} from '@jumpcloud/ui-components';

export default {
  name: 'SharedFolderSystemUsersItemListToolbar',

  components: {
    InputSearch,
  },

  props: {
    searchPlaceholder: {
      default: 'Search',
      type: String,
    },

    searchTerm: {
      default: '',
      type: String,
    },

    shouldFocusSearch: Boolean,
  },

  methods: {
    triggerSearch(value) {
      this.$emit('triggerSearch', value);
    },
  },
};
</script>

<style scoped>
  .toolbar {
    display: flex;
    padding: var(--jc-spacer) 0 0.25rem;
  }

  .search {
    flex: 0 1 35ch;
  }
</style>
